// extracted by mini-css-extract-plugin
export var layoutContainer = "_b6-0";
export var layoutContainerNoRounding = "_b6-6";
export var layoutContainerOpen = "_b6-5";
export var layoutContainerResizing = "_b6-1";
export var mainContent = "_b6-2";
export var resizeDivider = "_b6-3";
export var slidePanel = "_b6-4";